<template>
  <div class="wrap-committee-members">
    <Title
      :main="titleName"
      :des="descName"
    />
    <div class="box-select">
      <select
        v-model="categoryId"
      >
        <option
          v-for="category in categorys"
          :key="category.id"
          :value="category.id"
          >
          {{ category.aboutcommit_category}}
        </option>
      </select>
    </div>
    <div class="box-content">
      <div class="box-head">
        <div></div>
        <h2>{{ title }}</h2>
      </div>
      <b-row v-if="isLoading">
        <b-col
          v-for="i in 3"
          :key="i"
          cols="12"
          md="6"
          lg="4"
          class="col"
        >
          <Skeleton

            width="100%"
            height="412px"
          />
          <div class="box-dec-loading">
            <Skeleton
              v-for="i in 3"
              :key="i"
              width="100%"
              height="18px"
            />
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading">
        <b-col
          v-for="committee in committees"
          :key="committee.id"
          cols="12"
          md="4"
          lg="3"
          class="col"
          v-show="committee.active"
        >
          <img loading="lazy" :src="`${baseURL}/storage/app/img/about/committee/${committee.committee_picture}`">
          <div class="box-dec">
            <div class="box-title">
              <div></div>
              <h3>{{ committee.name }}</h3>
            </div>
            <div class="box-content" v-html="committee.content"></div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

const Skeleton = () => import('@/components/Loading/Skeleton')
const Title = () => import('./Parts/Title')

export default {
  components: {
    Skeleton,
    Title
  },

  data () {
    return {
      categoryId: 1,
      title: ''
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      isLoading: state => state.about.isLoading,
      categorys: state => state.about.categorys,
      committees: state => state.about.committees
    }),
    titleName () {
      const mConfig = this.configMap.get('managementcommittee_title')
      return mConfig ? mConfig.name : 'Adman Awards & Symposium'
    },
    descName () {
      const mConfig = this.configMap.get('managementcommittee_desc')
      return mConfig ? mConfig.name : 'Management Committee'
    }
  },

  methods: {
    filterCategory (id) {
      if (this.categorys) {
        this.$store.dispatch('about/getCommittee', id)

        const filter = this.categorys.filter(category =>
          category.id === id
        )

        this.title = filter[0].aboutcommit_category
      }
    }
  },

  created () {
    if (!this.categorys) {
      this.$store.dispatch('about/getCategory')
    }

    this.filterCategory(this.categoryId)
  },

  watch: {
    categorys () {
      this.filterCategory(this.categoryId)
    },

    categoryId (id) {
      this.filterCategory(id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-committee-members {
  padding: 22px 0;

  .box-select {
    select {
      width: 100%;
      padding: 6px 50px 6px 12px;
      border-radius: 0;
      border: 1px solid #888;
      background-color: white;
      background-image: url('../../assets/icons/icon-caret-down.png');
      background-repeat: no-repeat;
      background-position: right .7em top 50%, 0 0;
      background-size: 30px auto, 100%;
      font-size: 1.25rem;
    }

    @media only screen and (min-width: $break-m) {
      width: 50%;
    }

    @media only screen and (min-width: $break-l) {
      width: 30%;
    }
  }

  .box-content {
    .box-head {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 6px;
      padding: 18px 0;
      border-bottom: 6px solid rgb(173, 173, 173);

      div {
        width: 25px;
        height: 25px;
        background-color: $active;
      }

      h2 {
        margin-left: 12px;
        font-size: 1.5rem;

        @media only screen and (min-width: $break-l) {
          font-size: 1.75rem;
        }
      }
    }

    .row {
      .col {
        padding: 12px;
        img {
          width: 100%;
          height: 312px;
          background-color: #CCC;
          object-position: 50% 20%;
        }

        .box-dec-loading {
          margin-top: 22px;

          div {
            margin-top: 12px;
          }
        }

        .box-dec {
          .box-title {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-top: 12px;

            div {
              width: 12px;
              height: 12px;
              background-color: $active;
              align-self: flex-start;
              margin-top: 8px;
            }

            h3 {
              margin-left: 6px;
              font-size: 1.40rem;
            }
          }

          .box-content {
            margin: 4px 0 0 22px;
            font-size: 0.875rem;
            line-height: 1.5;
            font-family: var(--body-upscale-font-family, Sarabun);
          }

          ul {
            margin-left: 38px;

            li {
              padding: 4px 0;
              line-height: 1;
              font-size: 1.25rem;
            }
          }
        }
      }
    }
  }
}
</style>
